<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<h1>Export Users</h1>
	<br />

	<app-user-pools-dropdown-field
		[fg]="form"
		formGroupOrControlName="userPoolId"
		label="User Pool"
	></app-user-pools-dropdown-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
	</div>
</form>
